import { Box, Button, Typography, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import SitoImage from "sito-image";

//icons
import ChatIcon from "@mui/icons-material/Chat";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import { dislikeNews as dislike, likeNews as like, removeHtmlTags } from "../../../../actions";

// @emotion/css
import { css } from "@emotion/css";
import { addItemsToLocalStorage } from "../../../../utils/functions";
import { useDispatch, useSelector } from "react-redux";
import {
    dislikeNewsAction as dislikeAction,
    likeNewsAction as likeAction,
} from "../../../../redux/slices/userSlice";

const NewsDeploymentCard = ({ item, logo = "", source = "", tags = null }) => {
    const { id } = item;

    const news = useSelector((state) => state.news);

    const dispatch = useDispatch();

    const theme = useTheme();
    const [isLike, setIsLike] = useState(false);
    const [isDisLike, setIsDisLike] = useState(false);

    useEffect(() => {
        setIsLike(news[id] == "L");
        setIsDisLike(news[id] == "D");
    }, [id, news]);

    const handleLike = () => {
        setIsLike(true);
        setIsDisLike(false);
        dispatch(likeAction({ id: id }));
        if (!news[id]) {
            like(id)
                .then(() => {})
                .catch((err) => console.log(err));
        }
    };

    const handleDislike = () => {
        setIsLike(false);
        setIsDisLike(true);
        dispatch(dislikeAction({ id: id }));
        if (!news[id]) {
            dislike(id)
                .then(() => {})
                .catch((err) => console.log(err));
        }
    };

    const randomGradient = `gradient-${Math.floor(Math.random() * 10) + 1}`;
    const handleAddTagsOnClick = (e) => {
        addItemsToLocalStorage("newsTags", tags);
    };

    return (
        <Box
            onClick={tags && handleAddTagsOnClick}
            sx={{
                display: "flex",
                flexDirection: "column",
                borderBottom: "1px solid gray",
                width: "100%",
                marginTop: "10px",
                cursor: "pointer",
            }}
        >
            <a
                href={item?.link}
                target="_blank"
                rel="noreferrer"
                className={css({
                    color: "inherit",
                    textDecoration: "none",
                })}
            >
                <Box sx={{ width: "100%", display: "flex" }}>
                    <Box
                        sx={{
                            width: item?.image ? "40%" : "0px",
                            maxHeight: "170px",
                            //height: { xs: "200px", sm: "210px",},
                        }}
                    >
                        {item?.image && (
                            <Box
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    padding: "0 18px 18px 18px",
                                    borderRadius: "5px",
                                }}
                            >
                                <SitoImage
                                    className={randomGradient}
                                    sx={{
                                        borderRadius: "10px",
                                        objectFit: "cover",
                                    }}
                                    src={item?.image}
                                />
                            </Box>
                        )}
                    </Box>
                    <Box
                        sx={{
                            width: item?.image ? "60%" : "100%",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                width: "auto",
                                paddingX: "3px",
                                borderRadius: "10px",
                                fontFamily: "serif",
                            }}
                        >
                            {logo && (
                                <img
                                    src={logo}
                                    alt=""
                                    style={{
                                        width: "1rem",
                                        height: "1rem",
                                        borderRadius: "2px",
                                    }}
                                />
                            )}

                            <Typography sx={{ pl: "5px" }}>{source}</Typography>
                        </Box>{" "}
                        <Typography
                            sx={{
                                fontSize: { xs: "16px", sm: "18px" },
                                textAlign: "justify",
                                padding: "10px",
                                fontWeight: "600",
                            }}
                        >
                            {removeHtmlTags(item?.title)}
                        </Typography>
                    </Box>
                </Box>
            </a>
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "5px",
                }}
            >
                <Button
                    onClick={handleLike}
                    sx={{
                        display: "flex",
                        color: theme.palette.primary.main,
                        alignItems: "center",
                    }}
                >
                    {!isLike ? (
                        <ThumbUpOffAltIcon
                            sx={{
                                width: "18px",
                                height: "18px",
                                marginRight: "5px",
                                cursor: "pointer",
                            }}
                        />
                    ) : (
                        <ThumbUpAltIcon
                            sx={{
                                width: "18px",
                                height: "18px",
                                marginRight: "5px",
                                cursor: "pointer",
                            }}
                        />
                    )}
                    <Typography sx={{ color: "gray", fontSize: "13px" }}>{item?.likes}</Typography>
                </Button>
                <Button
                    onClick={handleDislike}
                    sx={{
                        display: "flex",
                        color: theme.palette.primary.main,
                        alignItems: "center",
                    }}
                >
                    {!isDisLike ? (
                        <ThumbDownOffAltIcon
                            sx={{
                                width: "18px",
                                height: "18px",
                                marginRight: "5px",
                                cursor: "pointer",
                            }}
                        />
                    ) : (
                        <ThumbDownAltIcon
                            sx={{
                                width: "18px",
                                height: "18px",
                                marginRight: "5px",
                                cursor: "pointer",
                            }}
                        />
                    )}
                    <Typography sx={{ color: "gray", fontSize: "13px" }}>{item?.dislikes}</Typography>
                </Button>
                {item?.debate ? (
                    <Button
                        sx={{
                            display: "flex",
                            color: theme.palette.primary.main,
                            alignItems: "center",
                        }}
                    >
                        <ChatIcon sx={{ width: "18px", height: "18px", marginRight: "5px" }} />
                        <Typography sx={{ color: "gray", fontSize: "13px" }}>
                            {item?.debate?.comments}
                        </Typography>
                    </Button>
                ) : (
                    " "
                )}
            </Box>
        </Box>
    );
};

export default NewsDeploymentCard;
